import { useState, useCallback } from 'react';
import ReactPlayer from 'react-player/lazy';
import ModalWrapper from './ModalWrapper';

function Video({ url, disableDownload }: { url?: string; disableDownload?: boolean }) {
  const [isCompleted, setIsCompleted] = useState(false);

  const VIDEO_COMPLETION_PERCENT = 0.8;

  const handleVideoProgress = useCallback(
    ({ played }) => {
      if (played >= VIDEO_COMPLETION_PERCENT && !isCompleted) {
        setIsCompleted(true);
      }
    },
    [isCompleted],
  );

  return (
    <ModalWrapper animated={false}>
      <div className="relative" style={{ paddingTop: '56.25%' }}>
        <ReactPlayer
          className="absolute top-0 left-0"
          url={url}
          width="100%"
          height="100%"
          controls
          onProgress={handleVideoProgress}
          config={
            disableDownload
              ? {
                  file: {
                    attributes: {
                      controlsList: 'nodownload',
                    },
                  },
                }
              : undefined
          }
        />
      </div>
    </ModalWrapper>
  );
}

export default Video;
